import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { ContentHeaderComponent } from './components/content-header/content-header.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { PipesModule } from '../theme/pipes/pipes.module';
import { BusyIndicatorComponent } from './components/busy-indicator/busy-indicator.component';
import { LogoSmallComponent } from './components/logo-small/logo-small.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfilePicComponent } from './components/profile-pic/profile-pic.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NguCarouselModule } from '@ngu/carousel';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to'; // TODO: Remove and use ngx-perfect-scrollbar
import { AppLoadingComponent } from './components/app-loading/app-loading.component';
import { TrueFalseDialogComponent } from './components/true-false-dialog/true-false-dialog.component';
import { SaveButtonComponent } from './components/save-button/save-button.component';
import { EditButtonComponent } from './components/edit-button/edit-button.component';
import { DeleteButtonComponent } from './components/delete-button/delete-button.component';
import { DiscardButtonComponent } from './components/discard-button/discard-button.component';
import { SkipButtonComponent } from './components/skip-button/skip-button.component';
import { CreateEditFooterComponent } from './components/create-edit-footer/create-edit-footer.component';
import { AddButtonComponent } from './components/add-button/add-button.component';
import { SearchButtonComponent } from './components/search-button/search-button.component';
import { ResetSearchButtonComponent } from './components/reset-search-button/reset-search-button.component';
import { TableSearchHeaderComponent } from './components/table-search-header/table-search-header.component';
import { CustomFormTextInputComponent } from './components/custom-form-text-input/custom-form-text-input.component';
import { TableEditDeleteButtonsComponent } from './components/table-edit-delete-buttons/table-edit-delete-buttons.component';
import { ToggleRowDetailsComponent } from './components/toggle-row-details/toggle-row-details.component';
import { LabelForComponent } from './components/label-for/label-for.component';
import { DynamicTableComponent } from './components/dynamic-table/dynamic-table.component';

@NgModule({
	imports: [
		CommonModule,
		ScrollToModule.forRoot(),
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		FlexLayoutModule,
		MatAutocompleteModule,
		MatButtonModule,
		MatButtonToggleModule,
		MatCardModule,
		MatCheckboxModule,
		MatChipsModule,
		MatDatepickerModule,
		MatDialogModule,
		MatExpansionModule,
		MatGridListModule,
		MatIconModule,
		MatInputModule,
		MatListModule,
		MatMenuModule,
		MatNativeDateModule,
		MatPaginatorModule,
		MatProgressBarModule,
		MatProgressSpinnerModule,
		MatRadioModule,
		MatRippleModule,
		MatSelectModule,
		MatSidenavModule,
		MatSliderModule,
		MatSlideToggleModule,
		MatSnackBarModule,
		MatSortModule,
		MatTableModule,
		MatTabsModule,
		MatToolbarModule,
		MatTooltipModule,
		MatStepperModule,
		MatTreeModule,
		PipesModule,
		NgxDatatableModule,
		NguCarouselModule,
	],
	exports: [
		CommonModule,
		FormsModule,
		ScrollToModule,
		ReactiveFormsModule,
		FlexLayoutModule,
		MatAutocompleteModule,
		MatButtonModule,
		MatButtonToggleModule,
		MatCardModule,
		MatCheckboxModule,
		MatChipsModule,
		MatDatepickerModule,
		MatDialogModule,
		MatExpansionModule,
		MatGridListModule,
		MatIconModule,
		MatInputModule,
		MatListModule,
		MatMenuModule,
		MatNativeDateModule,
		MatPaginatorModule,
		MatProgressBarModule,
		MatProgressSpinnerModule,
		MatRadioModule,
		MatRippleModule,
		MatSelectModule,
		MatSidenavModule,
		MatSliderModule,
		MatSlideToggleModule,
		MatSnackBarModule,
		MatSortModule,
		MatTableModule,
		MatTabsModule,
		MatToolbarModule,
		MatTooltipModule,
		MatTreeModule,
		MatStepperModule,
		NgxDatatableModule,
		NguCarouselModule,
		ContentHeaderComponent,
		BreadcrumbComponent,
		BusyIndicatorComponent,
		LogoSmallComponent,
		PipesModule,
		ProfilePicComponent,
		AppLoadingComponent,
		TrueFalseDialogComponent,
		SaveButtonComponent,
		EditButtonComponent,
		DeleteButtonComponent,
		DiscardButtonComponent,
		SkipButtonComponent,
		CreateEditFooterComponent,
		AddButtonComponent,
		SearchButtonComponent,
		ResetSearchButtonComponent,
		TableSearchHeaderComponent,
		CustomFormTextInputComponent,
		TableEditDeleteButtonsComponent,
		ToggleRowDetailsComponent,
		LabelForComponent,
		DynamicTableComponent,
	],
	declarations: [
		ContentHeaderComponent,
		BreadcrumbComponent,
		BusyIndicatorComponent,
		LogoSmallComponent,
		ProfilePicComponent,
		AppLoadingComponent,
		TrueFalseDialogComponent,
		SaveButtonComponent,
		EditButtonComponent,
		DeleteButtonComponent,
		DiscardButtonComponent,
		SkipButtonComponent,
		CreateEditFooterComponent,
		AddButtonComponent,
		SearchButtonComponent,
		ResetSearchButtonComponent,
		TableSearchHeaderComponent,
		CustomFormTextInputComponent,
		TableEditDeleteButtonsComponent,
		ToggleRowDetailsComponent,
		LabelForComponent,
		DynamicTableComponent,
	],
})
export class SharedModule { }
